import TSfDefaultEntry from './index.vue';

TSfDefaultEntry.install = app => {
  app.component(TSfDefaultEntry.name, TSfDefaultEntry);
};

export default TSfDefaultEntry;
